import { render } from "./OrderFile.vue?vue&type=template&id=5676235e&scoped=true"
import script from "./OrderFile.vue?vue&type=script&lang=ts"
export * from "./OrderFile.vue?vue&type=script&lang=ts"

import "./OrderFile.vue?vue&type=style&index=0&id=5676235e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5676235e"

export default script